module.exports = __webpack_public_path__ + "img/card_v6.1e7f51f.png";